<template>
  <div>
    <h3>
      {{ titleobj.projectLeaderName }}负责的项目【{{ titleobj.name }}】已开始{{
        titleobj.useTime
      }}天，当前进度 “{{ titleobj.stateName }}”
    </h3>
    <div class="tab-list">
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
            <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <Row justify="space-around" class="code-row-bg">
      <Col span="6">进度节点</Col>
      <Col span="4">时间</Col>
      <Col span="4">结果文件</Col>
      <Col span="4">进度</Col>
      <Col span="6">活动</Col>
    </Row>
    <div class="addactivity">
      <Card
        v-for="(v, k) in Data"
        :key="k"
        :bordered="true"
        style="margin: 10px 0"
        v-show="Data.length > 0"
      >
        <Row justify="space-around" class="code-row-bg1" :gutter="30">
          <Col span="6">
            <Badge>
              <div class="left" @click="handleDoubleClick(v)">
                <Icon
                  class="left_icon"
                  type="md-arrow-forward"
                  size="18"
                  :color="titleobj.percentage == v.scheduleProportion ? 'red' : 'white'"
                />
                <div :class="titleobj.percentage >= v.scheduleProportion ? 'lv' : 'hui'">
                  <p class="text">
                    <i
                      :class="
                        titleobj.percentage >= v.scheduleProportion
                          ? 'el-icon-circle-check'
                          : 'el-icon-remove-outline'
                      "
                    ></i>
                    {{ v.scheduleName }}
                  </p>
                </div>
              </div>
            </Badge>
          </Col>
          <Col span="4">
            <p>{{ v.updateTime ? v.updateTime : v.createTime }}</p>
          </Col>
          <Col span="4">
            <div style="display: flex; align-items: center; justify-content: center">
              <svg
                v-show="v.fileUrl ? (v.fileUrl ? true : false) : false"
                @click="handleRender(v.fileUrl, v.id)"
                class="icon"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
              >
                <path
                  d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                  fill="#CCA352"
                />
                <path
                  d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                  fill="#FFFFFF"
                />
                <path
                  d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                  fill="#FFCC66"
                />
              </svg>
              <svg
                v-show="v.fileUrl ? false : true"
                @click="handleRender(v.fileUrl, v.id)"
                class="icon"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
              >
                <path
                  d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                  fill="#515a6e"
                />
                <path
                  d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                  fill="#FFFFFF"
                />
                <path
                  d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                  fill="#e5e7eb"
                />
              </svg>
              <Button
                style="margin-left: 5px"
                icon="ios-cloud-upload-outline"
                type="text"
                shape="circle"
                @click="Upload(v)"
              ></Button>
            </div>
          </Col>
          <Col span="4">{{ v.scheduleProportion }}%</Col>
          <Col span="6">
            <Button
              style="margin-right: 5px"
              icon="ios-brush-outline"
              type="text"
              shape="circle"
              @click="addactivity(v)"
            ></Button>
            <Button
              icon="ios-eye-outline"
              @click="getInfo(v)"
              type="text"
              shape="circle"
            ></Button>
          </Col>
        </Row>
      </Card>
      <Card
        v-show="Data.length == 0 ? true : false"
        :bordered="true"
        style="margin: 10px 0"
      >
        <p>暂无进度</p>
      </Card>
    </div>
    <Modal
      v-model="modal"
      title="修改进度"
      @on-ok="onConfirm"
      @on-cancel="cancel()"
      class-name="vertical-center-modal"
    >
      <div class="modal">
        <p>
          确认修改项目进度为<span style="color: #2d41ef">{{ stateName }}</span
          >吗?
        </p>
      </div>
    </Modal>
    <Modal
      v-model="url"
      title="上传结果文件"
      @on-ok="onUpload"
      @on-cancel="oncancel"
      class-name="vertical-center-modal"
    >
      <p class="ge">仅支持以下格式:doc, docx, xls, xlsx, ppt, pptx, pdf, txt</p>
      <uploadFile2 ref="uploadFile2Ref" type="document" v-model="remarkUrl"></uploadFile2>
    </Modal>
  </div>
</template>

<script>
import config from "../../../../config";
import uploadFile2 from "@/views/components/common/form/uploadFile2.vue";
import Addactivity from "./addactivity.vue";
let customerId = window.localStorage.getItem("customerId");
export default {
  components: {
    uploadFile2,
  },
  data() {
    return {
      menus: [
        {
          label: "项目全景",
          name: "panorama",
        },
        {
          label: " 跟进记录",
          name: "schedule_Info",
        },
        {
          label: "任务",
          name: "task_Info",
        },
        {
          label: Number(customerId) == 0 ? "客户" : "供应商",
          name: "supplier_List",
        },
        {
          label: "合同",
          name: "contract_Info",
        },
        {
          label: "发票/支付",
          name: "invoice_Info",
        },
      ],
      Data: [],
      menu_name: "",
      customerId: "",
      schedule: Number(""),
      projectId: window.localStorage.getItem("projectId"),
      titleobj: {},
      modal: false,
      stateName: "",
      url: false,
      remarkUrl: "",
      remarkUrlcopy: "",
      scheduleId: "",
      Id: "",
    };
  },
  created() {
    let route = this.$route;
    this.initData(this.projectId);
    this.getschedule(this.projectId);
    if (route) {
      this.menu_name = route.name;
    }
  },
  methods: {
    getInfo(row) {
      $utils.url.push({ name: "schedule_Info", query: { scheduleId: row.scheduleId } });
    },
    addactivity(a) {
      let row = { id: a.id, schedule: a.scheduleId };
      console.log(row);
      this.$Modal.success({
        title: "新建activity",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <Addactivity id={this.Id} data={row} Edit="add" />
            </div>
          );
        },
      });
    },
    onUpload() {
      let url = this.remarkUrl + (this.remarkUrlcopy ? "," + this.remarkUrlcopy : "");
      let q = {
        fileUrl: url,
        id: this.scheduleId,
      };
      $utils.api
        .load(`/admin/system/managementContent`, q, "PUT")
        .then((res) => {
          if (res.status) {
            $utils.toast.success("保存成功");
            this.initData(this.projectId);
            this.getschedule(this.projectId);
          }
        })
        .catch((e) => {
          $utils.toast.error("保存异常" + e.message);
        });
    },
    Upload(data) {
      this.url = true;
      this.scheduleId = data.id;
      this.$refs.uploadFile2Ref.list = [];
      this.remarkUrl = "";
      this.remarkUrlcopy = data.fileUrl;
    },
    oncancel() {
      this.remarkUrl = "";
      this.$refs.uploadFile2Ref.list = [];
    },
    handleDoubleClick(data) {
      this.modal = true;
      this.stateName = data.scheduleName;
      this.scheduleId = data.scheduleId;
    },
    onConfirm() {
      let q = {
        state: this.scheduleId,
        id: this.projectId,
      };
      $utils.api
        .load(`/admin/system/management/editState`, q, "POST")
        .then((res) => {
          if (res.status) {
            $utils.toast.success(res.message);
            this.initData(this.projectId);
            this.getschedule(this.projectId);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    handleRender(text, id) {
      if (!text) {
        $utils.toast.error("暂无文件!");
        return;
      }
      this.scheduleId = id;
      const texturl = text.split(",").map((url) => config.IMAGE_HOST + url);
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "500px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              {files.map((item, i) => (
                <div
                  style="display:flex;justify-content: space-between;border: 1px solid #dcdee2; padding: 10px;border-radius: 5px;"
                  key={i}
                >
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                  <p
                    style="color:#2d8cf0;cursor: pointer;"
                    onClick={() => {
                      this.handleDelete(i, text);
                    }}
                  >
                    删除
                  </p>
                </div>
              ))}
            </div>
          );
        },
      });
    },

    handleDelete(i, text) {
      const inputString = text;
      const urlArray = inputString.split(",");
      urlArray.splice(i, 1);
      const resultString = urlArray.join(",");

      let q = {
        fileUrl: resultString,
        id: this.scheduleId,
      };

      $utils.api
        .load(`/admin/system/managementContent`, q, "PUT")
        .then((res) => {
          if (res.status) {
            $utils.toast.success("保存成功");
            this.initData(this.projectId);
            this.getschedule(this.projectId);
            this.$Modal.remove();
          }
        })
        .catch((e) => {
          $utils.toast.error("保存异常: " + e.message);
        });
    },
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/${id}`);
        try {
          if (res.code == 200) {
            this.titleobj = res.data;
            if (res.data.scheduleId) {
              this.Id = res.data.scheduleId;
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    async getschedule(id) {
      let q = { projectId: id };
      let res = await $utils.api.load(`/admin/system/managementContent/list`, q, "get");
      if (res.code == 200) {
        let list = res.rows || [];
        this.Data = list;
      }
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal {
  p {
    margin: 0 auto;
    font-size: 18px;
  }
}
.left {
  display: flex;
  cursor: pointer;

  .left_icon {
    padding-top: 5px;
    margin-right: 10px;
    text-align: center;
  }
}
.addactivity {
  margin-top: 10px;
}

.icon {
  cursor: pointer;
}

.code-row-bg {
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  color: black;
}

.code-row-bg1 {
  text-align: center;
}

.hui {
  background-color: #e5e7eb;
  padding: 5px;
  border-radius: 5px;
  color: #a5aab8;
}

.lv {
  background-color: #dbebdf;
  padding: 5px;
  border-radius: 5px;
  color: #4baf50;
}

.text {
  line-height: 20px;
}
.ge {
  font-size: 14px;
  color: #a5aab8;
  margin-bottom: 10px;
}
</style>
